import { render, staticRenderFns } from "./BalanceDetailModal.vue?vue&type=template&id=15108698&scoped=true&"
import script from "./BalanceDetailModal.vue?vue&type=script&lang=js&"
export * from "./BalanceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDetailModal.vue?vue&type=style&index=0&id=15108698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15108698",
  null
  
)

export default component.exports